import 'assets/css/app.scss';

const loadedComponents = [];

document.addEventListener( 'DOMContentLoaded', async () => {
	// Javascript has been loaded, remove the no-js class and replace for js class.
	document.documentElement.classList.remove('no-js');
	document.documentElement.classList.add('js');

	/**
	 * Bootstrap the components
	 */
	for ( const dataComponent of document.querySelectorAll( '[data-component]' ) ) {
		let componentName = dataComponent.dataset.component;
		let componentFolder = dataComponent.dataset.folder;
		
		let componentFolderName = componentName;

		if (componentFolder != undefined && componentFolder != '') {
			componentFolderName = componentFolder + '/' + componentName;
		}

		if ( loadedComponents.indexOf( componentFolderName ) === - 1 ) {
			loadedComponents.push( componentFolderName );

			let component = null;

			try {
				component = await import(
					/* WebpackMode: "lazy" */
					/* webpackPrefetch: true */
					`components/${componentFolderName}/${componentName}.js`
				);
			} catch ( error ) {
				// If a child theme is active, then check if the component exists in the child theme and load it from there.
				if (theme_object.child_theme_path) {
					try {
						component = await import(
							/* WebpackMode: "lazy" */
							/* webpackPrefetch: true */
							/* webpackIgnore: true */
							`${theme_object.child_theme_path}/components/${componentFolderName}/${componentName}.js`
						);
					} catch ( error ) {
						console.error( 'Loading error: ', error );
					}
				} else {
					console.error( 'Loading error: ', error );
				}
			}

			if (component != null) {
				component.default();
			}
			dataComponent.classList.add('component-loaded');
		} else {
			dataComponent.classList.add('component-loaded');
		}
	}
} );

// Load slider component so that sliders can be initialized in the child theme
import 'components/slider/slider.js';

import 'assets/js/extra.js';
import 'assets/js/data-href.js';
import 'assets/js/animations.js';